import {
  carrierStatusFormatter,
  dateFormatter,
  getLegalEntityName,
  localeFormatter,
  orderServiceFormatter,
  orderServiceFormatter2, smevCheckWithContentFormatter,
  vehiclesFormatter,
} from '../../../utils/formatters';

export const carrierColumns = [
  {
    dataField: 'number',
    text: 'Номер разрешения',
    headerClassName: 'registry-number-column',
    formatter: (a, item) => smevCheckWithContentFormatter(a || 'Номер не указан', item?.checks_status || '', item?.federal_law_number),
  },
  {
    dataField: 'created_at',
    text: 'Дата выдачи разрешения',
    headerClassName: 'registry-date-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'full_name',
    text: 'Наименование перевозчика',
    headerClassName: 'registry-commercial-name-column',
    formatter: (_, a) => getLegalEntityName(a),
  },
  {
    dataField: 'inn',
    text: 'ИНН',
    headerClassName: 'registry-inn-column',
  },
  {
    dataField: 'ogrn',
    text: 'ОГРН/ОГРНИП',
    headerClassName: 'registry-ogrn-column',
  },
  {
    dataField: 'status',
    text: 'Статус',
    headerClassName: 'registry-status-column',
    formatter: a => carrierStatusFormatter(a),
  },
  /*
  {
    dataField: 'carriage_contract_effective_date',
    text: 'Дата начала срока действия права',
    headerClassName: 'effective-date',
    formatter: dateFormatter,
  },
  {
    dataField: 'carriage_contract_expiration_date',
    text: 'Дата окончания срока действия права',
    headerClassName: 'expiration-date',
    formatter: dateFormatter,
  },
  */
];

export const additionalCarrierColumns = [
  {
    dataField: 'phone',
    headerClassName: 'effective-date',
  },
  {
    dataField: 'effective_date',
    headerClassName: 'effective-date',
    formatter: dateFormatter,
  },
  {
    dataField: 'legal_entity_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('user.type', a),
  },
  {
    dataField: 'has_employees',
    headerClassName: 'additional-column',
    formatter: a => (a ? 'Да' : 'Нет'),
  },
  {
    dataField: 'driver_license_series',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'driver_license_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'driver_license_issue_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'driver_license_expiration_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'medical_examination_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'decision',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'decision_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'commercial_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'osgop_insurances',
    headerClassName: 'additional-column',
    formatter: e => e && e[0]?.insurer,
    disableSort: true,
  },
  {
    dataField: 'osgop_insurances',
    text: 'Номер полиса ОСГОП',
    headerClassName: 'additional-column',
    formatter: e => e && e[0]?.insurance_contract_number,
    disableSort: true,
  },
  {
    dataField: 'osgop_insurances',
    text: 'Дата заключения договора ОСГОП',
    headerClassName: 'additional-column',
    formatter: e => e && dateFormatter(e[0]?.insurance_contract_effective_date),
    disableSort: true,
  },
  {
    dataField: 'osgop_insurances',
    text: 'Дата окончания срока действия договора ОСГОП',
    headerClassName: 'additional-column',
    formatter: e => e && dateFormatter(e[0]?.insurance_contract_expiration_date),
    disableSort: true,
  },
  {
    dataField: 'carriage_contract_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'carriage_contract_effective_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'carriage_contract_expiration_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'vehicles',
    text: 'Реестр ЛТ',
    headerClassName: 'order-service-formatter',
    formatter: vehiclesFormatter,
    disableSort: true,
  },
  {
    dataField: 'order_services',
    text: 'Реестр СЗЛТ',
    headerClassName: 'order-service-formatter',
    formatter: orderServiceFormatter2,
    disableSort: true,
  },
  {
    dataField: 'short_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'snils',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'legal_entity_form',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'last_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'first_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'middle_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'birth_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'gender',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('gender', a),
  },
  {
    dataField: 'citizenship',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('citizenship.type', a),
  },
  {
    dataField: 'place_of_birth',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('identity.type', a),
  },
  {
    dataField: 'identity_series',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_issue_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'identity_expiration_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'identity_issuer',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'legal_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'email',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'office_address',
    headerClassName: 'additional-column',
  },
];
